import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IWebsocketsState, WEBSOCKETS_FEATURE_KEY } from './websockets.reducer';

const webSocketsState = createFeatureSelector<IWebsocketsState>(WEBSOCKETS_FEATURE_KEY);

export const getEndpointWithToken = createSelector(webSocketsState, state => state?.endpointWithToken);
